/* eslint-disable no-param-reassign */

// const state = {
//   user: null,
// };

// const mutations = {
//   loginUser(state, data) {
//     state.user = data.user;
//   },
//   logoutUser(state) {
//     state.user = null;
//   },
// };

// const getters = {
//   user: state => state.user,
// };

export default {
  state: {
    user: null,
  },
  mutations: {
    loginUser(state, data) {
      state.user = data.user;
    },
    logoutUser(state) {
      state.user = null;
    },
  },
  getters: {
    user: state => state.user,
  },
};



// WEBPACK FOOTER //
// ./src/store/user.js